<h2 class="terra-headline-3 section-heading">{{ ccc }}</h2>

<h3 class="terra-title-bold section-title">{{ discussion.seatName }}</h3>

@if (isEos) {
  <ul class="section-list">
    @for (rating of formRoleRatings; track rating) {
      <li class="terra-body">{{ rating.role.name }}</li>
    }
  </ul>
}

<p class="terra-body section-desc">
  @if (isEos) {
    Select “Yes” or “No” as it pertains to the responsibilities of the role occupied by
    <strong>{{ discussion.managee | userName }}</strong>
    .
  } @else {
    Select "Yes", "Maybe" or "No" for each of
    <strong>{{ discussion.managee | userName }}'s</strong>
    responsibilities.
  }
</p>

<ng-template #ratingOptionsTemplate>
  @for (rating of ratingOptions; track rating.value) {
    <ion-segment-button
      [value]="rating.value"
      [disabled]="form.disabled"
      [class.positive]="rating.value === RoleRating.YES"
      [class.negative]="rating.value === RoleRating.NO"
      [class.neutral]="rating.value === RoleRating.MAYBE">
      <div class="segment-button-inner">
        <ion-icon [name]="rating.icon" class="segment-icon" />
        <span>{{ rating.label }}</span>
      </div>
    </ion-segment-button>
  }
</ng-template>

<ion-list [formGroup]="form">
  @for (roleRating of managerCtrls.ratings.controls; track roleRating; let i = $index) {
    @if (!isEos) {
      <h3 class="terra-title-small section-question-heading">
        {{ discussion.managerDiscussionForm?.roleRatings?.[i]?.role?.name }}
      </h3>
      <!--      <p>{{ discussion.managerDiscussionForm?.roleRatings?.[i]?.role?.description }}</p>-->
    }

    @if (isMeeting || isManager) {
      @if (isMeeting) {
        <p>{{ discussion.manager | userName }}</p>
      }

      <p class="terra-body section-question-desc">{{ competency }}</p>
      <ion-segment [formControl]="roleRating.controls.getsIt">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>

      <p class="terra-body section-question-desc">{{ commitment }}</p>
      <ion-segment [formControl]="roleRating.controls.wantsIt">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>

      <p class="terra-body section-question-desc">{{ capacity }}</p>
      <ion-segment [formControl]="roleRating.controls.hasCapacity">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>
    }

    @if (isMeeting || isManagee) {
      @if (isMeeting) {
        <p>{{ discussion.managee | userName }}</p>
      }

      <p class="terra-body section-question-desc">{{ language.competency }}</p>
      <ion-segment [formControl]="manageeCtrls.ratings.controls[i].controls.getsIt">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>

      <p class="terra-body section-question-desc">{{ language.commitment }}</p>
      <ion-segment [formControl]="manageeCtrls.ratings.controls[i].controls.wantsIt">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>

      <p class="terra-body section-question-desc">{{ language.capacity }}</p>
      <ion-segment [formControl]="manageeCtrls.ratings.controls[i].controls.hasCapacity">
        <ng-container *ngTemplateOutlet="ratingOptionsTemplate" />
      </ion-segment>
    }
  }
</ion-list>

@if (isMeeting || isManager) {
  <nty-textarea
    [formControl]="form.controls.manager.controls.notes"
    [label]="managerCommentLabel"
    placeholder="Enter comments" />
}

@if (isMeeting || isManagee) {
  <nty-textarea
    [formControl]="form.controls.managee.controls.notes"
    [label]="manageeCommentLabel"
    placeholder="Enter comments" />
}
